import React, {useEffect, useState} from 'react';
import {useUser, useUserPermissions} from "../../auth/userHooks";
import _ from "lodash";
import {getD365UnfoundProjects} from "../../api/d365Api";
import {Button, Col, Input, PageHeader, Row} from "antd";
import {ReloadOutlined, SearchOutlined} from "@ant-design/icons";
import {UnfoundProjectButton} from "./UnfoundProjectButton";
import {handleResponse} from "./utils";
import {UnfoundProjectsTable} from "./UnfoundProjectsTable";

const UnfoundProjects = () => {
  const [loading, setLoading] = useState(false);
  const [unfoundProjects, setUnfoundProjects] = useState([]);
  const [filteredUnfoundProjects, setFilteredUnfoundProjects] = useState([]);
  const permissions = useUserPermissions();
  const user = useUser();


  const filterUnfoundProjects = (unfoundProjects, searchText) => {
    var lcSearchText = _.toLower(searchText)
    setFilteredUnfoundProjects(
      _.chain(unfoundProjects)
        .filter(
          (i) =>
            searchText === "" ||
            _.includes(_.toLower(i.projectCode), lcSearchText)
        ).value()
    );
  };

  const search = (text) => {
    filterUnfoundProjects(unfoundProjects, text);
  }

  const loadUnfoundProjects = async () => {
    try {
      setLoading(true);
      const unfoundProjects = await getD365UnfoundProjects();
      setUnfoundProjects(unfoundProjects);
      filterUnfoundProjects(unfoundProjects);
    } catch (e) {
      console.error('Could not get unfound projects');
    } finally {
      setLoading(false);
    }
  };

  const handleUnfoundProjectResponse = (response, action) => {
    handleResponse(response, "Unfound Project", action);
    loadUnfoundProjects();
  };

  useEffect(() => {
    loadUnfoundProjects();
    // eslint-disable-next-line
  }, [])

  return (
    <>
      <Row>
        <Col span={12}>
          <PageHeader
            title="Unfound Projects"
            subTitle={`(${filteredUnfoundProjects.length} shown)`}
            style={{padding: 0}}
          />
        </Col>
      </Row>

      <Row style={{marginBottom: 10}}>
        <Col span={16} style={{marginRight: 10}}>
          <Input
            style={{maxWidth: 400}}
            placeholder="Search for unfound projects by project code"
            prefix={<SearchOutlined/>}
            onChange={(e) => search(e.target.value)}
            allowClear
          />
        </Col>
        <Col flex="auto">
          <Button
            style={{float: 'right'}}
            onClick={() => loadUnfoundProjects()}
            loading={loading}
            icon={<ReloadOutlined/>}
          >
            Refresh
          </Button>
          {permissions !== null && permissions.canManageExpenses && (
            <>
              <UnfoundProjectButton
                disabled={loading}
                isEdit={false}
                title={"Create Unfound Project"}
                email={user.email}
                record={{
                  'ID': 0,
                  'projectCode': '',
                  'action': 'IGNORE',
                  'mapProjectCode': ''
                }}
                onCompleted={handleUnfoundProjectResponse}
                style={{marginRight: 10, align: "center", float: "right"}}
              />
            </>
          )}
        </Col>
      </Row>
      <UnfoundProjectsTable
        unfoundProjects={filteredUnfoundProjects}
        loading={loading}
        permissions={permissions}
        user={user}
        handleUnfoundProjectResponse={handleUnfoundProjectResponse}
      />
    </>
  );
}

export {UnfoundProjects};